export default __webpack_public_path__ + "static/media/10Min.a8a44c84.svg";